import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useParametersNavigation } from "./useParametersNavigation";

export const useParametersPageState = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tabs, getTabKeyFromPath } = useParametersNavigation();
  const [selectedTab, setSelectedTab] = useState<string>(tabs[0]?.key ?? "");

  useEffect(() => {
    const tabKey = getTabKeyFromPath(location.pathname);
    if (tabKey && tabKey !== selectedTab) {
      setSelectedTab(tabKey);
    }
  }, [location.pathname, getTabKeyFromPath, selectedTab]);

  const handleTabChange = (key: string) => {
    const tab = tabs.find((t) => t.key === key);
    if (tab) {
      navigate(tab.path);
      setSelectedTab(key);
    }
  };

  return {
    tabs,
    selectedTab,
    handleTabChange,
  };
};
